<template>
    <VJoyWrapper class="reviews-indicator" no-margin column-gap="0" wrap="nowrap">
        <VJoyIcon name="star-fill" color="quaternary" size="xsmall" />
        <VJoyLink class="reviews-indicator__link" :class="{'reviews-indicator__link--bold': mf}" @click="onReviewsClicked()">
            {{ appraisals.ratings.general }}({{ appraisals.numberOfAppraisalsWithRating }})
        </VJoyLink>
    </VJoyWrapper>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyIcon, VJoyWrapper, VJoyLink} from '@maltjoy/core-vue';
    import {useProfileTracking} from '~/composables/useProfileTracking';
    import {useScrollToElement} from '~/composables/useScrollToElement';
    import {anchorsPageProfile} from '~/config/anchors';
    import {ProfileSectionReachedSection, ProfileSectionReachedEntryPoint, ProfileSectionReachedContext} from '~/config/TrackingEvents';
    import {useProfileStore} from '~/store/profileStore';
    import type {Appraisals} from '~/types/domain/Appraisals';

    const props = defineProps<{
        appraisals: Appraisals;
        mf?: boolean;
    }>();

    const {trackProfileSectionReached} = useProfileTracking();
    const {profile} = storeToRefs(useProfileStore());
    const {scrollToAnchor} = useScrollToElement();

    function onReviewsClicked() {
        scrollToAnchor(`#${anchorsPageProfile.appraisalsSection}`);
        trackProfileSectionReached(
            ProfileSectionReachedSection.REVIEWS,
            ProfileSectionReachedEntryPoint.HEADER_STARS,
            profile.value?.profileId,
            profile.value?.accountId,
            props.mf ? ProfileSectionReachedContext.PROFILE_DRAWER : ProfileSectionReachedContext.PROFILE_PAGE,
        );
    }
</script>
<style scoped lang="scss">
    .reviews-indicator {
        max-height: 18px;

        &__link {
            font-weight: var(--joy-font-weight-normal);
            white-space: nowrap;
            &--bold {
                font-weight: var(--joy-font-weight-bold);
            }
        }
    }
</style>
